/**
 * Adds scroll-trigger + fade-in to #MainContent sections that do not already
 * contain animated descendants. Must load before animations.js so the observer
 * picks up these nodes in a single pass.
 */
(function () {
  function enhanceSections(root) {
    if (!window.themeEditorialReveal) return;
    if (window.themeAnimationsFastMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let sections;
    if (!root || root.nodeType !== 1) {
      const main = document.getElementById('MainContent');
      if (!main) return;
      sections = main.querySelectorAll(':scope > .shopify-section');
    } else if (root.id === 'MainContent') {
      sections = root.querySelectorAll(':scope > .shopify-section');
    } else if (root.classList.contains('shopify-section')) {
      sections = [root];
    } else {
      sections = root.querySelectorAll('.shopify-section');
    }

    sections.forEach((section) => {
      if (section.querySelector('.scroll-trigger')) return;
      section.classList.add('scroll-trigger', 'animate--fade-in');
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    enhanceSections(document.getElementById('MainContent'));
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      enhanceSections(event.target);
    });
  }
})();
